<script setup lang="ts">
import '@/styles';
import BarsIcon from '@fortawesome/fontawesome-free/svgs/solid/bars.svg?component';
import { useHead } from '@unhead/vue';
import type { Component } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import DefaultActions from '@/components/actions/DefaultActions.vue';
import NavBar from '@/components/NavBar.vue';
import RouterQueryView from '@/core/RouterQueryView.vue';

useHead({
  titleTemplate: (title) => (title ? title + ' - ' : '') + $t`Castalian Spring`,
});

const router = useRouter();
const route = useRoute();

defineProps<{
  actions?: Component | null;
}>();
</script>

<template>
  <header :class="[$style.header, 'container-lg']">
    <h1>
      <RouterLink to="/" :title="$t`Castalian Spring`" />
    </h1>

    <button
      class="btn btn-lg btn-link link-body"
      @click="router.push({ query: { ...route.query, nav: null } })"
    >
      <BarsIcon class="inline-fill" />
    </button>

    <component :is="actions" v-if="actions" />

    <DefaultActions v-else-if="actions !== null" />
  </header>

  <RouterQueryView v-slot="{ back }" name="nav" :leave-duration="500">
    <NavBar :back="back" />
  </RouterQueryView>

  <main>
    <slot></slot>
  </main>
</template>

<style lang="scss" module>
.header {
  position: sticky;
  top: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: calc(51px + #{$spacer * 2});
  background-color: $body-bg;
  z-index: $zindex-sticky;

  @include media-breakpoint-down(sm) {
    min-height: calc(43px + #{$spacer * 2});
  }

  h1 {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    margin-bottom: 0;
    padding: $spacer 0;

    a {
      background: url('@/assets/images/header-logo.svg') no-repeat center /
        cover;
      display: block;
      height: 100%;
      aspect-ratio: 202.6 / 51;
    }
  }
}
</style>
